import React, { useState } from "react";
import PropTypes from "prop-types";
import { ADMIN_PAYMENT_METHOD } from "common/components/admin-payment-form-proptypes";
import { useApplyCouponCodeMutation } from "../campaigns-api-endpoints";
import AddWeeksModal from "../add-weeks-modal";
import CampaignGroupPropType from "../campaign-group-prop-type";
import PurchaseFlowModals from "./purchase-flow-modals";

const propTypes = {
  campaignGroup: CampaignGroupPropType.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  adminPaymentMethod: ADMIN_PAYMENT_METHOD,
  onRefetch: PropTypes.func
};

const AddWeeksPurchaseFlow = ({
  campaignGroup,
  isOpen,
  onClose,
  adminPaymentMethod = null,
  onRefetch = () => {}
}) => {
  const [displayPurchaseModal, setDisplayPurchaseModal] = useState(false);
  const [purchaseModalData, setPurchaseModalData] = useState({});
  const [couponData, setCouponData] = useState({});
  const [couponErrorData, setCouponErrorData] = useState({});

  const [verifyCouponCode, { isLoading: isVerifying }] = useApplyCouponCodeMutation();

  const handleAddWeeksSubmit = (_event, selectedPackage, selectedImpression) => {
    setPurchaseModalData({
      showPaymentFailNote: false,
      showUpgradeSell: false,
      showOrderSummary: true,
      confirmationButtonText: "Purchase",
      overridePackage: selectedPackage,
      impressionBoost: selectedImpression,
      formTarget: campaignGroup.add_weeks_link,
      applyCouponLink: campaignGroup.apply_coupon_link
    });
    setCouponData({});
    onClose();
    setDisplayPurchaseModal(true);
  };

  const handleApplyCoupon = async (couponCode, target) => {
    setCouponErrorData({});
    try {
      const response = await verifyCouponCode({
        applyCouponUrl: target,
        params: { coupon: { code: couponCode }, add_weeks: true }
      }).unwrap();
      setCouponData(response);
    } catch (err) {
      setCouponErrorData(err.data || "Unable to apply coupon");
    }
  };

  return (
    <>
      <AddWeeksModal
        fetchCampaignPackagesPath={campaignGroup.fetch_campaign_packages_path}
        isOpen={isOpen}
        toggle={onClose}
        onSubmit={handleAddWeeksSubmit}
        eligibleImpressionBoosts={campaignGroup.eligible_impression_boosts || []}
      />
      <PurchaseFlowModals
        campaignGroup={campaignGroup}
        purchaseModalData={purchaseModalData}
        displayPurchaseModal={displayPurchaseModal}
        setDisplayPurchaseModal={setDisplayPurchaseModal}
        adminPaymentMethod={adminPaymentMethod}
        applyCouponCodeCallback={handleApplyCoupon}
        couponData={couponData}
        couponErrorData={couponErrorData}
        isVerifyingCoupon={isVerifying}
        purchaseSource="campaign_results"
        purchaseType="add_weeks"
        onRefetch={onRefetch}
        supportsStripeRetail
      />
    </>
  );
};

AddWeeksPurchaseFlow.propTypes = propTypes;

export default AddWeeksPurchaseFlow;
